import { MijnRoute } from '../../mijn-navigatie.model';

export const INVESTMENT_ORDER_ALLOCATION: MijnRoute = {
    path: ':id/automatisch-aankopen',
    navigationEvent: 'toOrderAllocation',
    regex: /^\/beleggen\/[^/]+\/automatisch-aankopen$/,
    webcomponent: 'mijn-beleggen-portfolio-webcomponent',
    internalPath: ':id/automatisch-aankopen'
};
